import client from "../api/client";

export const getDetail = (id) => {
  return client(`/api/attachments/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/attachments/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/attachments', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const getTypeList = (type) => {
    return client(`/api/attachments/type/${type}`, {method: 'get'}).then(({ data }) => data.data);
};

export const delModel = (id) => {
    return client(`/api/attachments/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useAttachmentService () {
  return {
    getTypeList,
    addEditModel,
    getDetail,
    delModel,
  };
}
